export const LEGAL_DOCUMENTARY_BASELINE = Object.freeze({
  availability: 'qualified-summary',
  totalStages: 6,
  currentStage: 'applicability',
  currentStageIndex: 1,
  externalDeliverableStatus: 'review',
  evidenceDate: '2026-08-16'
});

export const LEGAL_DOCUMENTARY_STAGES = Object.freeze([
  'inventory',
  'applicability',
  'drafting',
  'review',
  'validation',
  'adoption'
]);
